import { Fotter } from '../../components';
import casePage from './images/casePage.png';

import bier from './images/bier.png';
import NBA from './images/NBA.png';
import baiqiaodan from './images/baiqiaodan.png';
import nikeyang from './images/nikeyang.png';

import ol1 from './images/1.png';
import ol2 from './images/2.png';
import ol3 from './images/3.png';
import ol4 from './images/4.png';

import bt1 from './images/bt1.png';
import bt2 from './images/bt2.png';
import bt3 from './images/bt3.png';
import bt4 from './images/bt4.png';
import bt5 from './images/bt5.png';
import bt6 from './images/bt6.png';
import bt7 from './images/bt7.png';
import bt8 from './images/bt8.png';

import ls1 from './images/logoshot-1.jpg';
import ls2 from './images/logoshot-2.jpg';
import ls3 from './images/logoshot-3.jpg';
import ls4 from './images/logoshot-4.jpg';
import ls5 from './images/logoshot-5.jpg';
import ls6 from './images/logoshot-6.jpg';
import ls7 from './images/logoshot-7.jpg';
import ls8 from './images/logoshot-8.png';

import ot1 from './images/other1.jpg';
import ot2 from './images/other2.jpg';

import icon from '../HomePage/components/CustomerStories/images/customVideoPlayButton.png';

import styles from './index.module.css';
import { useState, useEffect } from 'react';
import classNames from 'classnames';

const text = {
    cn: {
        title: '客户案例',
        cards: [
            {
                col2: {
                    title: '欧陆之星',
                    description: '《欧陆之星》系列节目，一方面，通过走进欧洲足球生活，为中国球迷深度了解欧洲足坛搭建平台;另一方面，以多元形式及互动玩法，加深了欧冠长期合作伙伴喜力啤酒的行业形象，为现代体育营销带来新范例。'
                },
                col1: [
                    {
                        img: ol1,
                        video: 's0046ncc3sx',
                    },
                    {
                        img: ol2,
                        video: 't00469cpnr9',
                    },
                    {
                        img: ol3,
                        video: 'k0046tees4n',
                    },
                    {
                        img: ol4,
                        video: 'c0046rbzi67',
                    },
                ]
            },
            {
                col2: {
                    title: '致美之旅',
                    description: '《致美之旅》是一档公路旅⾏节⽬，⾏程以凤凰城为起点，盐湖城为终点。旅途中包含【超级碗＋全明星】两⼤顶级赛事观赛体验以及特⾊城市、景点观光体验。ProLogue作为该节目的内容制作团队，负责了全部的内容制作工作。该节目在业内收获了极高的评价。'
                },
                col1: [
                    {
                        img: bt1,
                        video: 'm00456lkmdd',
                    },
                    {
                        img: bt2,
                        video: 'o004528gglm',
                    },
                    {
                        img: bt3,
                        video: 'h00456rffsw',
                    },
                    {
                        img: bt4,
                        video: 'b0045vji93j',
                    },
                    {
                        img: bt5,
                        video: 'o00454ke3zo',
                    },
                    {
                        img: bt6,
                        video: 'l0045y9l6z4',
                    },
                    {
                        img: bt7,
                        video: 'm0045nq4vr2',
                    },
                    {
                        img: bt8,
                        video: 'h00452hgl0v',
                    },
                ]
            },
            {
                col2: {
                    title: '投中那颗 LOGO SHOT',
                    description: '公司CEO沈洋为这一纪录片的项目发起人和总导演。纪录片主要讲述了包括曾凡博等7位在美国打球学习生活的中国篮球年轻一代的故事。影片是NBA中国和腾讯视频联合制作和发行，在业内引起了极大的反响，好评如潮。'
                },
                col1: [
                    {
                        img: ls1,
                        video: 'l3507hwh9ee',
                    },
                    {
                        img: ls2,
                        video: 'v350723q3c4',
                    },
                    {
                        img: ls3,
                        video: 'q00434ukjj2',
                    },
                    {
                        img: ls4,
                        video: 'r0043rx7epd',
                    },
                    {
                        img: ls5,
                        video: 'c0043po9cdb',
                    },
                    {
                        img: ls6,
                        video: 'o0043v1r7sg',
                    },
                    {
                        img: ls7,
                        video: 'm00435lsz6e',
                    },
                    {
                        img: ls8,
                        video: 'v3507kp37wh',
                    },
                ]
            },
            {
                col2: {
                    title: '“白乔丹”加盟街球霸王',
                    description: 'ProLogue 合作球员，世界最著名的扣将“白乔丹”Jordan Kilganon在2023年夏天加盟了NBA中国主办的火爆全国的街球联赛《街球霸王》全明星周末，并在扣篮大赛上以一骑绝尘之姿夺得冠军，而他的表现也引爆网络热潮，成为该项赛事的亮点之一。'
                },
                col1: [
                    {
                        img: baiqiaodan,
                        video: 'g351156mg5f',
                    },
                ]
            },
            {
                col2: {
                    title: '比尔落户快手',
                    description: '快手和Prologue的商业合作，把中国球迷最为喜爱的NBA球星比尔带到了快手平台，并且在一个小时的直播互动里，让中国的“老铁们”更加直接的和比尔进行交流，直播间气氛火爆，瞬时浏览量达到60万加。'
                },
                col1: [
                    {
                        img: bier,
                        video: 'z3511saous8',
                    },
                ]
            },
            {
                col2: {
                    title: '尼克杨与RIO品牌合作',
                    description: 'ProLogue促成NBA前球星尼克扬和中国知名酒精品牌Rio的独家合作，并且帮助拍摄和制作最终广告短片和平面照。该短片现已在抖音投放，客户反馈效果甚好。'
                },
                col1: [
                    {
                        img: nikeyang,
                        video: 'w3513aylj9o',
                    },
                ]
            },
            {
                col2: {
                    title: 'NBA周刊',
                    description: 'NBA周刊系列单元《这是可以说的吗》通过前方的镜头，向NBA球迷展现NBA季后赛紧张激烈的赛场气氛，让球迷身临其境感知淘汰赛和生死战的别样氛围。'
                },
                col1: [
                    {
                        img: NBA,
                        video: 'y3520llzg52',
                    },
                ]
            },
        ],
        others: {
            title: '其他',
            col1: [
                {
                    img: ot1,
                    video: 't35063vsx6s',
                },
                {
                    img: ot2,
                    video: 'e3506cq6xw3',
                },
            ]
        }
    },
    en: {
        title: 'CUSTOMER CASE',
        cards: [
            {
                col2: {
                    title: 'THE START OF EUROPE',
                    description: 'By entering the European football life, we build a platform for Chinese fans to have a deep understanding of European football. On the other hand, with multiple forms and interactive play, it deepens the industry image of Heineken Beer, a long-term partner of the Champions League, and brings a new paradigm for modern sports marketing.'
                },
                col1: [
                    {
                        img: ol1,
                        video: 's0046ncc3sx',
                    },
                    {
                        img: ol2,
                        video: 't00469cpnr9',
                    },
                    {
                        img: ol3,
                        video: 'k0046tees4n',
                    },
                    {
                        img: ol4,
                        video: 'c0046rbzi67',
                    },
                ]
            },
            {
                col2: {
                    title: 'EXPERIENCE THE POWER OF LEGEND',
                    description: '"Experience The Power of Legend"is a road trip show that starts in Phoenix and ends in Salt Lake City. The trip includes the Super Bowl and the All-Star Game, as well as the sightseeing experience of featured cities and scenic spots.ProLogue, as the content production team for the show, wasresponsible for all the content production work and received high praise from the industry.'
                },
                col1: [
                    {
                        img: bt1,
                        video: 'm00456lkmdd',
                    },
                    {
                        img: bt2,
                        video: 'o004528gglm',
                    },
                    {
                        img: bt3,
                        video: 'h00456rffsw',
                    },
                    {
                        img: bt4,
                        video: 'b0045vji93j',
                    },
                    {
                        img: bt5,
                        video: 'o00454ke3zo',
                    },
                    {
                        img: bt6,
                        video: 'l0045y9l6z4',
                    },
                    {
                        img: bt7,
                        video: 'm0045nq4vr2',
                    },
                    {
                        img: bt8,
                        video: 'h00452hgl0v',
                    },
                ]
            },
            {
                col2: {
                    title: 'LOGO SHOT',
                    description: 'ProLogue CEO Lisa Hsu served as the project leader and executive producer of the docuseries. The project – a joint production with NBA China and Tencent Video - went behind the scenes to document the stories of seven young Chinese athletes living their basketball dreams in the U.S., including Fanbo Zeng, Michael Wang, Fuqu Wang,Xinyi Li, Hao Hu, Yutong Zhang Since premiering, the docuseries have generated thoughtful discussions and positive reviews within China’s sports industry. '
                },
                col1: [
                    {
                        img: ls1,
                        video: 'l3507hwh9ee',
                    },
                    {
                        img: ls2,
                        video: 'v350723q3c4',
                    },
                    {
                        img: ls3,
                        video: 'q00434ukjj2',
                    },
                    {
                        img: ls4,
                        video: 'r0043rx7epd',
                    },
                    {
                        img: ls5,
                        video: 'c0043po9cdb',
                    },
                    {
                        img: ls6,
                        video: 'o0043v1r7sg',
                    },
                    {
                        img: ls7,
                        video: 'm00435lsz6e',
                    },
                    {
                        img: ls8,
                        video: 'v3507kp37wh',
                    },
                ]
            },
            {
                col2: {
                    title: '“白乔丹”加盟街球霸王',
                    description: 'ProLogue 合作球员，世界最著名的扣将“白乔丹”Jordan Kilganon在2023年夏天加盟了NBA中国主办的火爆全国的街球联赛《街球霸王》全明星周末，并在扣篮大赛上以一骑绝尘之姿夺得冠军，而他的表现也引爆网络热潮，成为该项赛事的亮点之一。'
                },
                col1: [
                    {
                        img: baiqiaodan,
                        video: 'g351156mg5f',
                    },
                ]
            },
            {
                col2: {
                    title: 'BRAD BEAL X KUAISHOU DEAL',
                    description: 'The commercial cooperation between Kuaishou and Prologue brought Brad Beal , the NBA star most loved by Chinese fans, to the Kuaishou platform, and in the one-hour live interaction, China'+'s "old iron" more directly communicate with Bill, the atmosphere of the broadcast room is hot, and the instant page views reached 600,000.'
                },
                col1: [
                    {
                        img: bier,
                        video: 'z3511saous8',
                    },
                ]
            },
            {
                col2: {
                    title: '尼克杨与RIO品牌合作',
                    description: 'ProLogue促成NBA前球星尼克扬和中国知名酒精品牌Rio的独家合作，并且帮助拍摄和制作最终广告短片和平面照。该短片现已在抖音投放，客户反馈效果甚好。'
                },
                col1: [
                    {
                        img: nikeyang,
                        video: 'w3513aylj9o',
                    },
                ]
            },
            {
                col2: {
                    title: 'NBA WEEK',
                    description: 'NBA Weekly series unit "Can it be said" through the front of the camera, to show NBA fans the tense atmosphere of the NBA playoffs, so that fans feel the elimination of the game and life and death of the different atmosphere.'
                },
                col1: [
                    {
                        img: NBA,
                        video: 'y3520llzg52',
                    },
                ]
            },
        ],
        others: {
            title: 'OTHER',
            col1: [
                {
                    img: ot1,
                    video: 't35063vsx6s',
                },
                {
                    img: ot2,
                    video: 'e3506cq6xw3',
                },
            ]
        }
    },
}

const CustomerCase = (props) => {
    const { l, path, setIsBlack } = props;
    const [current, setCurrent] = useState(1);
    const [lh, setLh] = useState(0);

    useEffect(() => {
        if (path === 'Customer Case') {
            window.addEventListener('scroll', () => {
                if (document.getElementById('custom-page')?.getBoundingClientRect().top < -document.getElementById('c-banner-h')?.clientHeight + 60) {
                    setIsBlack(true);
                } else {
                    setIsBlack(false);
                }
            });
            window.addEventListener('resize', () => {
                setLh(document.getElementById('custom-page')?.clientWidth * 0.018);
            })
        }

        return () => {
            window.removeEventListener('scroll', () => { });
        }
    }, [path])

    useEffect(() => {
        setLh(document.getElementById('custom-page')?.clientWidth * 0.018);
    }, [])

    useEffect(() => {
        console.log(lh)
    }, [lh])

    return (
        <div className={styles['page']} id='custom-page'>
            <div className={styles['banner']}>
                <img src={casePage} id='c-banner-h' className={styles['banner-img1']} alt='' />
                {/* <img src={casePage} className={styles['banner-img']} /> */}
                <div className={styles['banner-title']}>{text[l]['title']}</div>
            </div>
            <div className={styles['card-box']}>
                <div className={styles['title']}>{text[l]['title']}</div>
                <div className={styles['line']}>&nbsp;</div>
                {current === 1 && text[l]['cards'].map(item => (
                    <div className={styles['col-card']}>
                        <div className={styles['col2']}>
                            <div className={styles['col2-title']}>{item['col2']['title']}</div>
                            <div
                                className={classNames(styles['col2-des'])}
                                style={{
                                    lineHeight: l === 'cn' ? '28px' : 
                                    `${lh}px`,
                                }}
                            >
                                <div className={styles['col2-des-des']}>
                                    {item['col2']['description']}
                                </div>
                            </div>
                        </div>
                        {item['col1'].map(item => (
                            <div
                                className={styles['col1']}
                                onClick={() => {
                                    if (item.video) {
                                        window.Player(item.video);
                                    };
                                }}
                            >
                                <img src={item.img} className={styles['col1-img']} alt='' />
                                <img src={icon} className={styles['col1-icon']} alt='' />
                            </div>
                        ))}
                    </div>
                ))}
                {current === 2 && (
                    <>
                        <div className={styles['title-oth']}>{text[l]['others']['title']}</div>
                        <div className={styles['col-card-oth']}>
                            {text[l]['others']['col1'].map(item => (
                                <div
                                    className={styles['col1']}
                                    onClick={() => {
                                        if (item.video) {
                                            window.Player(item.video);
                                        };
                                    }}
                                >
                                    <img src={item.img} className={styles['col1-img']} alt='' />
                                    <img src={icon} className={styles['col1-icon']} alt='' />
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
            <div className={styles['pagination']}>
                {[1, 2].map(page => (
                    <div
                        className={styles['pagination-item']}
                        style={{
                            color: current === page ? '#097FFF' : undefined,
                            border: current === page ? '1px solid #097FFF' : undefined,
                        }}
                        onClick={() => {
                            setCurrent(page)
                        }}
                    >
                        {page}
                    </div>
                ))}
            </div>
            <Fotter l={l} />
        </div>
    )
}

export default CustomerCase;